if ($('.js-menuMobile').length > 0) {
  const menuMobile = $('.js-menuMobile');
  const body = $('body');
  // const submenuTitle = $('.js-submenuTitle');

  $(document).on('click', '.js-route-link', function() {
    const menu = $('.js-menu');
    const overlay = $('.js-overlay');
    const catalogParent = $('.js-openCatalog').parent();

    menuMobile.removeClass('is_show');
    body.removeClass('menu_open');
    menuMobile.removeClass('submenu_open');

    menu.removeClass('menu_open');
    overlay.removeClass('is_show');
    catalogParent.removeClass('is_active');
    $('.header__bottom-list .is_active').removeClass('is_active');
  });

  $(document).on('click', '.js-search__button', function() {
    $('.js-openMenuMobile').trigger( "click" );
  });

  $(document).on('click', '.js-openMenuMobile', function() {
    menuMobile.addClass('is_show');
    body.addClass('menu_open');
  });

  $(document).on('click', '.js-closeMenuMobile, .js-item-menu-clone-modal', function() {
    menuMobile.removeClass('is_show');
    body.removeClass('menu_open');
    menuMobile.removeClass('submenu_open');
  });

  $(document).on('click', '.js-openSubmenu', function() {
    let _this = $(this),
        content = $('' + _this.data('link-submenu') + '');
        // currentTitle = _this.text();

    menuMobile.addClass('submenu_open');
    // submenuTitle.text(currentTitle);

    content
      .addClass('is_open')
      .siblings()
      .removeClass('is_open');
  });

  $(document).on('click', '.js-closeSubmenu', function() {
    menuMobile.removeClass('submenu_open');
  });

}
